import React, { useEffect, useState } from "react";
import { PopperControl } from "../../../typings/grid";
import { getRichText, getButtonList, getCodeSnippet } from "../../../util/ModuleHelper";
import Text from "../../components/Text/Text";
import PopUpCard, { CloseButton } from "../../components/Card/PopUpCard";
import { absoluteURL } from "../../../util/UrlHelper";
import { ThemeConsumer, ThemeProvider } from "styled-components";
import { useTransition, animated } from "react-spring";
import { isBrowserContext } from "../../../util/ContextHelper";
import styled from "styled-components";
import ReactDOM from "react-dom";

const popupRoot = isBrowserContext() ? document.getElementById("popup-root") as HTMLDivElement : null;

interface PopperProps extends PopperControl
{
}

const PopperContainer = styled.div`
    position: fixed;
    right: 0;
    bottom: 30px;
    padding: 1rem;
    z-index: 100;
`;

const Popper: React.FC<PopperProps> = (props) =>
{
    const { image, blocks } = props;
    const [display, setDisplay] = useState(true);
    const [showPopper, setShowPopper] = useState(false);

    useEffect(() =>
    {
        // customer want popper to spawn after 5sec
        setTimeout(() => setShowPopper(true), 5000);
    }, []);

    if (!isBrowserContext() || !popupRoot)
    {
        return null;
    }

    const transitions = useTransition(display, null, {
        from: { transform: "translate3d(110%, 0, 0)" },
        enter: { transform: "translate3d(0%, 0, 0)" },
        leave: { transform: "translate3d(110%, 0, 0)" },
        delay: 500
    });

    if (showPopper)
    {
        return ReactDOM.createPortal(
            <ThemeConsumer>
                {theme =>
                    <ThemeProvider theme={{ ...theme, backgroundColor: "#fff" }}>
                        <PopperContainer>
                            {transitions.map(({ item, key, props }) =>
                                item && <animated.div key={key} style={props}>
                                    <PopUpCard
                                        image={image && image[0].url ? absoluteURL(image?.[0].url) : undefined}
                                        altText={image?.[0].properties.altText || ""}>
                                        <CloseButton onClick={() => setDisplay(!display)} />
                                        <Text>
                                            {blocks?.items.map((block) =>
                                            {
                                                switch (block.content.contentType)
                                                {
                                                    case "gridEditorRichText":
                                                        return getRichText(block as any);
                                                    case "gridEditorButtonList":
                                                        return getButtonList(block as any);
                                                    case "gridEditorCodeSnippet":
                                                        return getCodeSnippet(block as any);
                                                    default:
                                                        return null;
                                                }
                                            })}
                                        </Text>
                                    </PopUpCard>
                                </animated.div>
                            )}
                        </PopperContainer>
                    </ThemeProvider>
                }
            </ThemeConsumer>
            , popupRoot);
    }
    return null;
};

export default Popper;